import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ErrorState } from '@/shared/components/States';
import { theme } from '@/theme';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } } });

class RootErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override componentDidCatch(error: Error, info: ErrorInfo) { console.error('render failed', error.name, info.componentStack); }
  override render() {
    return this.state.failed ? <ErrorState message="The page could not be shown." onRetry={() => window.location.reload()} /> : this.props.children;
  }
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RootErrorBoundary>{children}</RootErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
